import React, { Fragment } from 'react';
interface CountdownTimerProps {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
  };
}
export function CountdownTimer({
  timeLeft
}: CountdownTimerProps) {
  const pad = (n: number) => n.toString().padStart(2, '0');
  const percentTaken = 68;
  return <section className="bg-cosmic-deep pt-6 md:pt-8 pb-8 md:pb-12 px-4" data-id="element-77" data-mp="1ocs4xvgpk4v1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-78" data-mp="1oanz37z90vs4">
        <h2 className="font-display font-bold text-danger text-xl md:text-3xl mb-5 md:mb-6 leading-tight" data-id="element-79" data-mp="1kbygn0zcso1m">
          <span className="block" data-id="element-80" data-mp="1fb0u6c7b97ub">⏰ PRECIO DE LANZAMIENTO</span>
          <span className="block" data-id="element-81" data-mp="1ac7h2kvxriuo">TERMINA EN:</span>
        </h2>

        <div className="flex justify-center items-end gap-3 md:gap-5 mb-4 md:mb-5" data-id="element-82" data-mp="1aetrqte4ieh4">
          {[{
          val: pad(timeLeft.hours),
          label: 'hs'
        }, {
          val: pad(timeLeft.minutes),
          label: 'min'
        }, {
          val: pad(timeLeft.seconds),
          label: 'seg'
        }].map((unit, i) => <Fragment key={i} data-id="element-83" data-mp="1gzi4uf0rzmtj" data-mpi={i}>
              <div className="flex flex-col items-center" data-id="element-84" data-mp="1h0t9eh21oylp">
                <div className="bg-[#1C1040] text-white font-display font-black text-4xl md:text-7xl px-4 md:px-8 py-4 md:py-6 rounded-2xl shadow-xl border border-gold/20 min-w-[90px] md:min-w-[140px]" data-id="element-85" data-mp="122iqm8bf4vq3">
                  {unit.val}
                </div>
                <span className="text-gold font-bold uppercase tracking-widest text-xs md:text-sm mt-2" data-id="element-86" data-mp="1urohhr4pzbo8">
                  {unit.label}
                </span>
              </div>
              {i < 2 && <div className="text-white/50 font-black text-4xl md:text-6xl pb-10" data-id="element-87" data-mp="1l13apgew70u8">
                  :
                </div>}
            </Fragment>)}
        </div>

        {/* Availability bar */}
        <div className="max-w-md mx-auto" data-id="element-88" data-mp="2do7jzxl0q1bt">
          <div className="flex items-center justify-between mb-1.5 text-[11px] md:text-sm font-bold uppercase tracking-wide" data-id="element-89" data-mp="2ihslw0pqffga">
            <span className="flex items-center gap-1.5 text-danger" data-id="element-90" data-mp="2sc7og2kgbsaw">
              <span className="w-2 h-2 rounded-full bg-danger pulse-soft" data-id="element-91" data-mp="2nepmiw4uqdce"></span>
              Cupos ocupados
            </span>
            <span className="text-white" data-id="element-92" data-mp="2jahxsyye8xe6">{percentTaken}%</span>
          </div>
          <div className="relative w-full h-3 md:h-4 bg-white/10 rounded-full overflow-hidden border border-white/10" role="progressbar" aria-valuenow={percentTaken} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos ocupados" data-id="element-93" data-mp="2ebwwsxbbi9oo">
            <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-danger to-orange rounded-full" style={{
            width: `${percentTaken}%`
          }} data-id="element-94" data-mp="1zolgyj83s3ir"></div>
          </div>
          <p className="mt-1.5 text-danger font-bold text-[11px] md:text-sm" data-id="element-95" data-mp="1loaq3g6smoxl">
            ¡Quedan pocos lugares disponibles!
          </p>
        </div>
      </div>
    </section>;
}